import globals from '../../globals';
import actionTypes from '../constants/action-types';

const changeHTML = (newHTML, globalsToUpdate = []) =>
  globals.helpers.globalActionExtender({
    type: actionTypes.CHANGE_HTML,
    payload: {
      newHTML,
      globalsToUpdate,
    },
  });

export default changeHTML;
